import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { clearActionMeta } from "Bands/state";
import { IBandActions } from "Bands/types";

export const useClearActionMetaOnUnMount = (action: IBandActions) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearActionMeta(action));
    };
  }, [dispatch, action]);

  return null;
};
